import { BaseEntity } from "../../baseEntity";

export class ConfVisualizationValue extends BaseEntity {

  protected readonly CODE_FILE_VALUE = "codeFileValue";

  get codeFileValue(): string { return this.getInternalValue<string>(this.CODE_FILE_VALUE); }
  setCodeFileValue(codeFileValue: string): this { return this.setInternalValue(this.CODE_FILE_VALUE, codeFileValue); }

}